import { useEffect, useState } from "react";

const InsuranceLookup_v05 = () => {
  const [category, setCategory] = useState<any>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    
    console.log("id", id);

    if (id) {
      // Fetch or look up the category data by ID
      //const response = await fetch(`/insiurance-data-documents/${selectedCategory.jsonDocument}`);
      fetch(`/api/categories/${id}`) // or use categories.find(...)
        .then((res) => res.json())
        .then((data) => setCategory(data));
    }
  }, []);

  if (!category) return <p>Loading...</p>;

  return (
    <div>
      <h1>{category.title}</h1>
      <p>{category.description}</p>
    </div>
  );
};

export default InsuranceLookup_v05;